













import Vue from 'vue';
import { get, map } from 'lodash';

import { getPersonLabel } from '@/utils/zen_objects/people';

import PeopleProfilePics from '../people-profile-pics/PeopleProfilePics.vue';
import { getCSRFToken, fetchRequestReviewers } from '../EvidenceCollection.effects';
import { Reviewers } from '../types';

export default Vue.extend({
  name: 'Reviewers',
  components: {
    PeopleProfilePics,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: <boolean>true,
      error: <boolean>false,
      reviewers: <Reviewers>{ edges: [] },
    };
  },
  computed: {
    csrfToken(): string {
      return this.getCSRFToken(this.$store);
    },

    displayReviewers(): boolean {
      const successfullyLoaded: boolean = !this.loading && !this.error;
      const hasReviewers: boolean = !!this.reviewers.edges.length;
      return successfullyLoaded && hasReviewers;
    },
    reviewersMessage(): string {
      const count: number = this.reviewers.edges.length;

      const reviewer: object | null = get(this.reviewers, 'edges[0].node.person.value', null);
      const reviewerLabel: string | null = reviewer && getPersonLabel(reviewer);

      const single: string = `Once you hit “Submit”, this evidence will be sent to ${reviewerLabel} for review.`;
      const multiple: string = 'Once you hit “Submit”, this evidence will be sent to these teammates for review.';

      if (count === 0) return '';
      if (count === 1) return single;
      return multiple;
    },
    reviewersProfilePicsModel() {
      return map(this.reviewers.edges, reviewerEdge => ({
        email: reviewerEdge.node.person.value.email.value,
        name: reviewerEdge.node.person.value.name.value,
        role: reviewerEdge.node.person.value.userRole.value,
        avatar: reviewerEdge.node.person.value.profileImageUrl.value,
      }));
    },
  },
  async created() {
    await this.fetchReviewers();
  },
  methods: {
    getCSRFToken,
    fetchRequestReviewers,
    getPersonLabel,

    async fetchReviewers() {
      // We pass Request's UUID to GQL call
      const requestId: string = `${this.type}:${this.id}`;

      const { result, error } = await this.fetchRequestReviewers(requestId);

      this.loading = false;

      if (error || !result) {
        this.error = error;
        return;
      }

      this.reviewers = get(result, 'data.node.reviewers.value', '');
    },
  },
});
